import React from 'react';
import styled from 'styled-components';

import { FolderTreeContainer } from './folder-tree-container';
import { FolderTreeHeader } from './folder-tree-header';

const FolderTreeSection = () => {
  return (
    <Component>
      <FolderTreeHeader />
      <FolderTreeContainer />
    </Component>
  );
};

const Component = styled.section`
  border-bottom: 1px solid #ddd;

  // New stacking context.
  isolation: isolate;
`;

export { FolderTreeSection };
